import { makeVar, useReactiveVar } from '@apollo/client';

export interface IUseCreateCollectionCache {
  createCollectionId: string | undefined;
  setCreateCollectionId: (value: string | undefined) => void;
}

export const createCollection = makeVar<string | undefined>(undefined);

export const useCreateCollectionCache = (): IUseCreateCollectionCache => {
  const createCollectionId = useReactiveVar(createCollection);

  const setCreateCollectionId = (value: string | undefined): void => {
    createCollection(value);
  };

  return {
    createCollectionId,
    setCreateCollectionId,
  };
};
